import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';

type Props = {
  title: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
};

export const CommissionsFormConditionsHeader: React.FC<Props> = ({ title, actions, children }) => {
  return (
    <Box mb={2} sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography fontWeight={500} variant="body1">
        {title}
      </Typography>
      <Box sx={{ display: 'flex', gap: '8px' }}>
        {actions}
        {children}
      </Box>
    </Box>
  );
};
